import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: "https://www.jmareports.com/keycloak",
  realm: "master",
  clientId: "react",
  // clientId: "react-dev", // for DEV envirnment
  // credentials: {
  //   secret: "lfc3KmMjAnnDpDN1EjSYeq7km5T0FeCi", // ⚠️ For testing only
  // },
});

export default keycloak;
